import React from 'react';

function SignalmanField({ value }) {
  if (!value) return <>-</>;

  if (value === 1) {
    return <>Segnalatore</>;
  } else if (value === 2) {
    return <>Responsabile di Zona</>;
  } else if (value === 3) {
    return <>Commerciale 1</>;
  } else if (value === 4) {
    return <>Commerciale 2</>;
  }

  return <>{value}</>;
}

export default SignalmanField;
